import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ServiceProviderSymbol } from '@wix/thunderbolt-symbols'
import { styleUtilsService } from './styleUtilsService'

export const site: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(styleUtilsService)
}

export const editor = site
